<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn @click.native="leave" color="error" icon flat>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline">{{loading ? 'Loading' : section.name}}</v-toolbar-title>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="px-2 pb-3" xs12 sm10>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-else class="py-3 px-2" row wrap justify-center>
        <v-flex v-if="courseEnded" class="py-5 my-5" xs12>
          <div class="text-xs-center display-3 grey--text text--lighten-1">
            Course Ended
          </div>
        </v-flex>
        <v-flex v-else-if="tasks.length == 0" class="py-5" xs12>
          <div class="text-xs-center display-3 grey--text text--lighten-1">
            Empty Section
          </div>
        </v-flex>
        <v-flex v-else class="px-2 pb-3" xs12 md10>
          <v-list class="pt-0">
            <v-list-tile
              v-for="t, i in tasks"
              :key="i"
              @click="goToTask(t.key)"
              ripple>
              <v-list-tile-content>
                <v-list-tile-title>
                  <span>{{t.name}}</span>
                  <v-icon v-if="t.complete" class="ml-2 mb-2" color="success">done</v-icon>
                  <v-icon v-else class="ml-2" color="-primary">play_arrow</v-icon>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
export default {
  components: {
    rCrumbs: Crumbs
  },
  data: () => ({
    loading: false,
    currentProgress: {},
    progress: {},
    contentProgress: {},
    sectionProgress: {},
    section: {},
    tasks: []
  }),
  computed: {
    now () {
      return this.$store.getters.now
    },
    courseEnded () {
      if (this.now > this.progress.endTime) this.$router.push('/my-courses')
      return this.now > this.progress.endTime
    }
  },
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      this.currentProgress = this.$store.getters.currentProgress
      this.progress = this.$store.getters.progressByKey(this.currentProgress.progress)
      this.section = this.$store.getters.sectionByKey(this.currentProgress.section)
      if (this.section) {
        let entry = {}
        let taskProgress = null
        for (let t of this.$store.getters.taskBySection(this.currentProgress.section)) {
          taskProgress = this.$store.getters.taskProgressByTaskByProgress(t.key, this.currentProgress.progress)
          entry = {
            ...t,
            complete: taskProgress ? taskProgress.complete : false
          }
          if (taskProgress) entry.complete = taskProgress.endTime ? (this.now > taskProgress.endTime) : entry.complete
          this.tasks.push(entry)
          this.tasks.sort((a, b) => {
            return a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'})
          })
        }
        this.loading = false
      } else {
        this.$store.dispatch('setCurrentProgress', {progress: null, section: null, task: null})
        this.$router.push('/my-courses')
      }
    },
    goToTask (taskKey) {
      this.$store.dispatch('setCurrentProgress', {
        progress: this.currentProgress.progress,
        section: this.currentProgress.section,
        task: taskKey
      })
      this.$router.push('/my-courses/course-view/my-tasks/task-view')
    },
    leave () {
      this.$store.dispatch('setCurrentProgress', {progress: this.currentProgress.progress, section: null, task: null})
      this.$router.push('/my-courses/course-view')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/myCourses/MyTaskList.vue